<!--
  Generated template for the WelcomePage page.

  See http://ionicframework.com/docs/components/#navigation for more info on
  Ionic pages and navigation.
-->

<ion-content fullscreen no-bounce class="tutorial-page">
	<ion-slides pager>
		<ion-slide class="p1">
			<ion-toolbar>
				<ion-buttons end>
					<button ion-button color="primary" (click)="skip()">{{'GLOBAL_SKIP' | translate}}</button>
				</ion-buttons>
			</ion-toolbar>
			<div class="pattern-bg"></div>
			<div class="vertical-center-outer">
				<div class="vertical-center-inner">
					<img src="/assets/imgs/spooorts_logo.svg" alt="sporttypes" class="slide-image" />
					<h1 text-bold padding-top>{{'WELCOME_P1_TITLE' | translate}}</h1>
					<p>{{'WELCOME_P1_SUBTITLE' | translate}}</p>
				</div>
			</div>
		</ion-slide>
		<ion-slide class="p2" [style.background-image]="'url(/assets/imgs/intro/tutorialbw.jpg)'">
			<ion-toolbar>
				<ion-buttons end>
					<button ion-button color="white" (click)="skip()">{{'GLOBAL_SKIP' | translate}}</button>
				</ion-buttons>
			</ion-toolbar>
			<h1 text-bold text-white class="top-title">{{'WELCOME_P2_TITLE' | translate}}</h1>
			<div class="vertical-center-outer">
				<div class="vertical-center-inner">
					<ion-card text-left class="event-card">
						<table>
							<tr>
								<td>{{'WELCOME_P2_SUNDAY' | translate}}</td>
							</tr>
							<tr>
								<td><img src="/assets/imgs/intro/circle-biker.svg" alt="sporttype-bike"
										class="slide-image" /> Berlin Marathon </td>
								<td text-right>42,195 km</td>
							</tr>
						</table>
					</ion-card>
					<ion-card text-left class="event-card">
						<table>
							<tr>
								<td>{{'WELCOME_P2_SUNDAY' | translate}}</td>
							</tr>
							<tr>
								<td><img src="/assets/imgs/intro/circle-runner.svg" alt="sporttype-running"
										class="slide-image" /> Hamburg Cyclassics</td>
								<td text-right>60/100/160 km</td>
							</tr>
						</table>
					</ion-card>
				</div>
			</div>
		</ion-slide>
		<ion-slide class="p3" [style.background-image]="'url(/assets/imgs/intro/tutorial-3.jpg)'">
			<ion-toolbar>
				<ion-buttons end>
					<button ion-button color="primary" (click)="skip()">{{'GLOBAL_SKIP' | translate}}</button>
				</ion-buttons>
			</ion-toolbar>
			<h1 text-bold class="top-title">{{'WELCOME_P3_TITLE' | translate}}</h1>
			<p>{{'WELCOME_P3_SUBTITLE' | translate}}</p>
			<img src="/assets/imgs/intro/intro_mobile_2.svg" alt="mobile-frame" class="mobile-frame" />
		</ion-slide>
		<!-- <ion-slide class="p4">
			<ion-toolbar>
			</ion-toolbar>
			<div class="vertical-center-outer">
				<div class="vertical-center-inner">
					<img src="/assets/imgs/intro/logo.svg" alt="logo" class="logo" />
					<div padding class="btn-wrapper" *ngIf="!isLoged()">
						<button ion-button block color="primary" (click)="showLogin()">
							{{'LOGIN_LOGIN' | translate}}
						</button>
					</div>
					<div padding-horizontal class="btn-wrapper">
						<button ion-button clear block icon-end color="primary" (click)="skip()">
							{{'GLOBAL_CONTINUE' | translate}}
							<ion-icon name="arrow-forward"></ion-icon>
						</button>
					</div>
				</div>
			</div>
		</ion-slide> -->
	</ion-slides>
</ion-content>